function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, useRef } from "react";
import { Skeleton, message, Descriptions, Button, Drawer, Divider, Tag, Tabs, Modal, Alert, Select, Form, Input, QRCode, Upload, List, Typography, Switch } from 'antd';
import Common from "./includes/Common";
import { Container, Row, Col } from 'react-bootstrap';
import { GenderMale, GenderFemale, CardChecklist, HospitalFill, ExclamationCircleFill, Upload as UploadIc, CheckCircleFill, XCircleFill } from 'react-bootstrap-icons';
import AddPatientItem from "./forms/AddPatientItem";
import Receipt from "./Receipt";
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var confirm = Modal.confirm;
var PatientView = function PatientView(_ref) {
  var pid = _ref.pid;
  var ref = useRef();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    customer = _useState2[0],
    setCustomer = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    isDataLoading = _useState4[0],
    setIsDataLoading = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isFormLoading = _useState6[0],
    setIsFormLoading = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    orderedItems = _useState8[0],
    setOrderedItems = _useState8[1];
  var _useState9 = useState([]),
    _useState0 = _slicedToArray(_useState9, 2),
    orderedOptions = _useState0[0],
    setOrderedOptions = _useState0[1];
  var _useState1 = useState([]),
    _useState10 = _slicedToArray(_useState1, 2),
    companies = _useState10[0],
    setCompanies = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    serviceTree = _useState12[0],
    setServiceTree = _useState12[1];
  var _useState13 = useState(0),
    _useState14 = _slicedToArray(_useState13, 2),
    isPdaActive = _useState14[0],
    setIsPdaActive = _useState14[1];
  var _useState15 = useState(""),
    _useState16 = _slicedToArray(_useState15, 2),
    successMessage = _useState16[0],
    setSuccessMessage = _useState16[1];
  var _useState17 = useState(""),
    _useState18 = _slicedToArray(_useState17, 2),
    errorMessage = _useState18[0],
    setErrorMessage = _useState18[1];
  var _useState19 = useState(true),
    _useState20 = _slicedToArray(_useState19, 2),
    dataChanged = _useState20[0],
    setDataChanged = _useState20[1];
  var _useState21 = useState([]),
    _useState22 = _slicedToArray(_useState21, 2),
    selectedItems = _useState22[0],
    setSelectedItems = _useState22[1];
  var _useState23 = useState([]),
    _useState24 = _slicedToArray(_useState23, 2),
    file = _useState24[0],
    setFile = _useState24[1];
  var _useState25 = useState(true),
    _useState26 = _slicedToArray(_useState25, 2),
    companyDisabled = _useState26[0],
    setCompanyDisabled = _useState26[1];
  var _useState27 = useState(null),
    _useState28 = _slicedToArray(_useState27, 2),
    userCompany = _useState28[0],
    setUserCompany = _useState28[1];
  var _useState29 = useState(true),
    _useState30 = _slicedToArray(_useState29, 2),
    uploadDisabled = _useState30[0],
    setUploadDisabled = _useState30[1];
  var _useState31 = useState(0),
    _useState32 = _slicedToArray(_useState31, 2),
    receipAmount = _useState32[0],
    setReceipAmount = _useState32[1];
  var _useState33 = useState([]),
    _useState34 = _slicedToArray(_useState33, 2),
    rdata = _useState34[0],
    setRdata = _useState34[1];
  var _useState35 = useState([]),
    _useState36 = _slicedToArray(_useState35, 2),
    companyOptions = _useState36[0],
    setCompanyOptions = _useState36[1];
  var _useState37 = useState(null),
    _useState38 = _slicedToArray(_useState37, 2),
    currentDepId = _useState38[0],
    setCurrentDepId = _useState38[1];
  var _useState39 = useState([]),
    _useState40 = _slicedToArray(_useState39, 2),
    discounts = _useState40[0],
    setDiscounts = _useState40[1];
  var _useState41 = useState(0),
    _useState42 = _slicedToArray(_useState41, 2),
    discount = _useState42[0],
    setDiscount = _useState42[1];
  var _useState43 = useState([{
      value: 0,
      label: "Direct"
    }]),
    _useState44 = _slicedToArray(_useState43, 2),
    bpOptions = _useState44[0],
    setBpOtions = _useState44[1];
  var _useState45 = useState(null),
    _useState46 = _slicedToArray(_useState45, 2),
    createdBill = _useState46[0],
    setCreatedBill = _useState46[1];
  var _useState47 = useState(false),
    _useState48 = _slicedToArray(_useState47, 2),
    showReceipt = _useState48[0],
    setShowReceipt = _useState48[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  function printR() {
    var content = document.getElementById("pvdiv");
    var pri = document.getElementById("ifmcontentstoprint").contentWindow;
    pri.document.open();
    pri.document.write(content.innerHTML);
    pri.document.close();
    pri.focus();
    pri.print();
  }
  var handlePdaChange = function handlePdaChange(checked) {
    setIsPdaActive(checked == true ? 1 : 0);
  };
  var props = {
    onRemove: function onRemove(file) {
      setFile(null);
    },
    beforeUpload: function beforeUpload(file) {
      setFile(file);
      return false;
    }
  };
  var handleOptChange = function handleOptChange(v) {
    setSelectedItems(v);
  };
  var categoryOptions = [{
    label: 'Particulier',
    value: 0
  }, {
    label: 'Conventionné',
    value: 1
  }];
  var onCategorieChanged = function onCategorieChanged(e) {
    if (e == 1) {
      setCompanyDisabled(false);
      form.setFieldsValue(customer.company.id);
      setUploadDisabled(false);
    } else {
      setUploadDisabled(true);
      setCompanyDisabled(true);
    }
  };
  var onCompanyChanged = function onCompanyChanged(v) {
    setUserCompany(companies.filter(function (c) {
      return c.id == v;
    })[0]);
  };
  var handleCommand = function handleCommand(values) {
    setErrorMessage("");
    setSuccessMessage("");
    var formData = new FormData();
    formData.append('category', customer.category);
    formData.append('company_id', customer.company_id);
    formData.append("uid", Common.currentUser.id);
    formData.append("pid", customer.id.toString());
    formData.append("file", file);
    formData.append("is_pda_active", isPdaActive);
    formData.append("discount", values.discount);
    formData.append("paid_amount", values.paid_amount);
    formData.append("business_provider_id", values.business_provider_id);
    var ta = 0;
    var oo = Array();
    var op = Array();
    var deptArray = Array();
    var prescriptionsIds = Array();
    setRdata([]);
    orderedItems.forEach(function (e) {
      if (selectedItems.includes(e.medical_item.id)) {
        //IF CASH PATIENT THE USE BASE PRICE 
        if (values.category == 0) {
          ta += e.medical_item.base_price;
          setRdata(function (prev) {
            return [].concat(_toConsumableArray(prev), [e.medical_item.label + " - " + e.medical_item.base_price.toLocaleString('fr') + " GNF"]);
          });
        } else {
          //HANDLING COMPANY PRICE CATEGORIES 
          var comp = companies.filter(function (c) {
            return c.id == values.company_id;
          })[0];
          setUserCompany(comp);
          if (comp.company_id == null) {
            ta += e.medical_item.ent_price * (1 + comp.commercial_rate / 100);
            setRdata(function (prev) {
              return [].concat(_toConsumableArray(prev), [e.medical_item.label + " - " + (e.medical_item.ent_price * (1 + comp.commercial_rate / 100)).toLocaleString('fr') + " GNF"]);
            });
          }
          if (comp.company_id != null && comp.company.type == 1) {
            ta += e.medical_item.ins_price;
            setRdata(function (prev) {
              return [].concat(_toConsumableArray(prev), [e.medical_item.label + " - " + (e.medical_item.ins_price * (1 + comp.company.commercial_rate / 100)).toLocaleString('fr') + " GNF"]);
            });
          }
          /* if(comp.company_id!=null && comp.company.type==2) {
               ta+= e.lan_price;    
               setRdata(prev => [...prev, e.label + " - "+e.lan_price.toLocaleString('fr') + " GNF"]);
           }*/
        }
        oo.push(e.medical_item.id);
        op.push(e.id);
        deptArray.push(e.medical_item.department_id);
        prescriptionsIds.push(e.id);
      }
    });
    ta -= values.discount / 100 * ta;
    formData.append("ordered_items", oo);
    formData.append("ordered_prescriptions", op);
    formData.append("department_id", deptArray.toString());

    //setOrderedOptions(oo); 
    formData.append('amount', ta);
    if (values.category == 1) {
      if (companies.filter(function (c) {
        return c.id == values.company_id;
      }).length > 0) {
        var company_rate = companies.filter(function (c) {
          return c.id == values.company_id;
        })[0].rate;
        setCurrentCompany(companies.filter(function (c) {
          return c.id == values.company_id;
        })[0]);
        formData.append('company_part', ta * company_rate * 0.01);
        formData.append('patient_part', ta * (100 - company_rate) * 0.01);
        setReceipAmount(ta * (100 - company_rate) * 0.01);
      }
    } else {
      formData.append("patient_part", ta);
      formData.append("company_part", 0);
      setReceipAmount(ta);
    }
    formData.append('prescriptions_ids', prescriptionsIds.toString());
    confirm({
      title: 'Confirmez-vous ?',
      icon: /*#__PURE__*/_jsx(ExclamationCircleFill, {}),
      content: /*#__PURE__*/_jsx(Receipt, {
        company: userCompany,
        discount: values.discount,
        is_pda_active: isPdaActive,
        options: oo.toString(),
        serviceTree: serviceTree
      }),
      onOk: function onOk() {
        var _iterator = _createForOfIteratorHelper(formData.entries()),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var pair = _step.value;
            console.log(pair[0] + ' - ' + pair[1]);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        execOrder(formData);
      },
      onCancel: function onCancel() {
        console.log('Cancel');
      }
    });
  };
  var execOrder = function execOrder(formData) {
    setIsFormLoading(true);
    axios.post(Common.baseApiUrl + 'executepatientorder', formData).then(function (response) {
      if (response.data.status == 200) {
        setSuccessMessage(response.data.message);
        setDataChanged(true);
        setCreatedBill(response.data.bill);
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
        //printR();   
        setShowReceipt(true);
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage('Une erreur est survenue ' + error.toString());
    })["finally"](function () {
      setIsFormLoading(false);
    });
  };
  useEffect(function () {
    form.setFieldsValue({
      discount: 0
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 0,
        label: "0%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 1,
        label: "1%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 2,
        label: "2%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 3,
        label: "3%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 4,
        label: "4%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 5,
        label: "5%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 10,
        label: "10%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 15,
        label: "15%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 20,
        label: "20%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 25,
        label: "25%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 30,
        label: "30%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 35,
        label: "35%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 40,
        label: "40%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 45,
        label: "45%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 50,
        label: "50%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 55,
        label: "55%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 60,
        label: "60%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 65,
        label: "65%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 70,
        label: "70%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 75,
        label: "75%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 80,
        label: "80%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 85,
        label: "85%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 90,
        label: "90%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 95,
        label: "95%"
      }]);
    });
    setDiscounts(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        value: 100,
        label: "100%"
      }]);
    });
    setIsDataLoading(true);
    setDataChanged(false);
    axios.all([axios.get(Common.baseApiUrl + "getcustomerbyid/" + pid.toString() + "/" + Common.currentUser.id), axios.get(Common.baseApiUrl + "getcustomerprescriptions/" + pid.toString() + "/" + Common.currentUser.id), axios.get(Common.baseApiUrl + "getcompanylist"), axios.get(Common.baseApiUrl + "getservicetree"), axios.get(Common.baseApiUrl + "getbusinessproviders/" + Common.currentUser.id)]).then(function (response) {
      if (response[0].data.status == 200) {
        setCustomer(response[0].data.patient);
      } else {
        message.error({
          content: response[0].data.message,
          delay: 4
        });
      }
      if (response[1].data.status == 200) {
        //setOrderedItems(response[1].data.prescriptions);  
        var ar = new Array();
        setOrderedItems([]);
        if (response[1].data.prescriptions.length > 0) {
          setOrderedOptions([]);
          response[1].data.prescriptions.forEach(function (p) {
            p.prescription_items.forEach(function (i) {
              //response[1].data.prescriptions.filter(p => (p.medical_item.department.dcode != "LUN" && p.medical_item.department.dcode != "PHA")).forEach(p => { 
              if (i.ordered == 0) {
                setOrderedOptions(function (prev) {
                  return [].concat(_toConsumableArray(prev), [{
                    label: i.medical_item.label,
                    value: i.medical_item.id
                  }]);
                });
                ar.push(i.medical_item.id);
                setSelectedItems(ar);
                setOrderedItems(function (prev) {
                  return [].concat(_toConsumableArray(prev), [i]);
                });
              }
              //});              
            });
          });
        }
        form.setFieldsValue({
          items: ar
        });
      }
      if (response[2].data.status == 200) {
        setCompanyOptions([]);
        setCompanies(response[2].data.companyList);
        response[2].data.companyList.forEach(function (c) {
          if (c.company_id == null) setCompanyOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: c.label,
              value: c.id
            }]);
          });else setCompanyOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: c.company == null ? "" : c.company.label + "-" + c.label,
              value: c.id
            }]);
          });
        });
      }
      if (response[3].data.status == 200) {
        setServiceTree(response[3].data.services);
      }
      if (response[4].data.status == 200) {
        response[4].data.providers.forEach(function (p) {
          setBpOtions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: p.id,
              label: p.name + " (" + p.origin + ")"
            }]);
          });
        });
      }
      form.setFieldsValue({
        category: 0,
        business_provider_id: 0
      });
    })["catch"](function (error) {
      message.error({
        content: error.toString(),
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [pid, dataChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("br", {}), isDataLoading && /*#__PURE__*/_jsx(Skeleton, {
      active: true
    }), customer != null && /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsxs(Col, {
            lg: 1,
            md: 1,
            sm: 1,
            xs: 1,
            children: [customer.gender == 'F' && /*#__PURE__*/_jsx(GenderFemale, {
              size: 35
            }), customer.gender == 'H' && /*#__PURE__*/_jsx(GenderMale, {
              size: 35
            })]
          }), /*#__PURE__*/_jsxs(Col, {
            lg: 4,
            md: 4,
            sm: 5,
            children: [/*#__PURE__*/_jsx("div", {
              className: "cool-radius user-personal-info",
              children: /*#__PURE__*/_jsxs(Descriptions, {
                column: 2,
                title: "Informations personelles",
                children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                  labelStyle: {
                    fontWeight: 'Bold'
                  },
                  span: 2,
                  contentStyle: {
                    fontWeight: 'Bold'
                  },
                  label: "ID PATIENT",
                  children: customer.idnumber
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: "Pr\xE9nom",
                  children: customer.firstname
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: "Nom",
                  children: customer.lastname
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: "Tel.",
                  children: customer.mobile
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: "Genre",
                  children: customer.gender
                })]
              })
            }), /*#__PURE__*/_jsx("br", {})]
          }), /*#__PURE__*/_jsx(Col, {
            lg: 7,
            md: 7,
            sm: 6,
            children: /*#__PURE__*/_jsxs(Tabs, {
              children: [/*#__PURE__*/_jsx(Tabs.TabPane, {
                tab: /*#__PURE__*/_jsx("b", {
                  children: "ORIENTATION PATIENT"
                }),
                children: /*#__PURE__*/_jsx(AddPatientItem, {
                  patient: customer
                })
              }, 1), /*#__PURE__*/_jsxs(Tabs.TabPane, {
                tab: /*#__PURE__*/_jsx("b", {
                  children: "PRESCRIPTION MEDECIN"
                }),
                children: [isDataLoading == false && orderedItems.length == 0 ? /*#__PURE__*/_jsx("div", {
                  style: {
                    textAlign: "center"
                  },
                  children: /*#__PURE__*/_jsx(Divider, {
                    children: "Aucune prescription"
                  })
                }) : /*#__PURE__*/_jsx("div", {}), customer != null && /*#__PURE__*/_jsxs(Form, {
                  form: form,
                  layout: "vertical",
                  onFinish: handleCommand,
                  children: [/*#__PURE__*/_jsx(Row, {
                    children: /*#__PURE__*/_jsx(Col, {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "business_provider_id",
                        label: "Provenance",
                        rules: [{
                          required: true,
                          message: 'Choisir la catégorie'
                        }],
                        children: /*#__PURE__*/_jsx(Select, {
                          showSearch: true,
                          defaultActiveFirstOption: true,
                          optionLabelProp: "label",
                          optionFilterProp: "label",
                          filterOption: function filterOption(input, option) {
                            return option.label.toLowerCase().includes(input.toLowerCase());
                          },
                          options: bpOptions
                        })
                      })
                    })
                  }), /*#__PURE__*/_jsxs(Row, {
                    children: [/*#__PURE__*/_jsx(Col, {
                      lg: 6,
                      md: 6,
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        label: "Articles",
                        name: "items",
                        rules: [{
                          required: true,
                          message: "Champ obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Select, {
                          onChange: handleOptChange,
                          mode: "multiple",
                          optionLabelProp: "label",
                          options: orderedOptions
                        })
                      })
                    }), /*#__PURE__*/_jsx(Col, {
                      lg: 6,
                      md: 6,
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "category",
                        label: "Cat\xE9gorie",
                        rules: [{
                          required: true,
                          message: 'Choisir la catégorie'
                        }],
                        children: /*#__PURE__*/_jsx(Select, {
                          showSearch: true,
                          onChange: onCategorieChanged,
                          optionLabelProp: "label",
                          defaultValue: [0],
                          optionFilterProp: "label",
                          filterOption: function filterOption(input, option) {
                            return option.label.toLowerCase().includes(input.toLowerCase());
                          },
                          options: categoryOptions
                        })
                      })
                    }), /*#__PURE__*/_jsx(Col, {
                      lg: 6,
                      md: 6,
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "company_id",
                        label: "Prise en charge",
                        children: /*#__PURE__*/_jsx(Select, {
                          onChange: onCompanyChanged,
                          disabled: companyDisabled,
                          showSearch: true,
                          options: companyOptions
                        })
                      })
                    }), /*#__PURE__*/_jsx(Col, {
                      lg: 6,
                      md: 6,
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "matricule",
                        label: "Bon de prise en charge",
                        children: /*#__PURE__*/_jsx(Input, {
                          disabled: companyDisabled,
                          placeholder: "Num prise en charge/ Matricule"
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs(Row, {
                    children: [/*#__PURE__*/_jsx(Col, {
                      lg: 8,
                      md: 7,
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "discount",
                        label: "Remise",
                        rules: [{
                          required: true,
                          message: "Champ obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Select, {
                          options: discounts
                        })
                      })
                    }), /*#__PURE__*/_jsx(Col, {
                      lg: 4,
                      md: 5,
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        label: "PDA",
                        children: /*#__PURE__*/_jsx(Switch, {
                          onChange: handlePdaChange,
                          size: "default",
                          checked: isPdaActive == 1,
                          checkedChildren: /*#__PURE__*/_jsx(CheckCircleFill, {}),
                          unCheckedChildren: /*#__PURE__*/_jsx(XCircleFill, {})
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsx(Row, {
                    children: /*#__PURE__*/_jsx(Col, {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "paid_amount",
                        children: /*#__PURE__*/_jsx(Input, {
                          placeholder: "Montant acompte",
                          disabled: !isPdaActive,
                          block: true
                        })
                      })
                    })
                  }), /*#__PURE__*/_jsx(Form.Item, {
                    children: /*#__PURE__*/_jsx(Button, {
                      htmlType: "submit",
                      type: "primary",
                      disabled: orderedOptions.length == 0,
                      children: /*#__PURE__*/_jsx("b", {
                        children: "VALIDER LA COMMANDE"
                      })
                    })
                  })]
                }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), successMessage && /*#__PURE__*/_jsx(Alert, {
                  type: "success",
                  message: successMessage,
                  banner: true
                }), errorMessage && /*#__PURE__*/_jsx(Alert, {
                  type: "error",
                  message: errorMessage,
                  banner: true
                })]
              }, 2)]
            })
          })]
        })
      })
    }), customer && /*#__PURE__*/_jsx(Drawer, {
      title: /*#__PURE__*/_jsxs("b", {
        children: [/*#__PURE__*/_jsx(CheckCircleFill, {
          size: 30
        }), " RECU"]
      }),
      width: "280px",
      open: showReceipt,
      onClose: function onClose() {
        setShowReceipt(false);
      },
      destroyOnClose: true,
      extra: [/*#__PURE__*/_jsx(ReactToPrint, {
        content: function content() {
          return ref.current;
        },
        children: /*#__PURE__*/_jsx(PrintContextConsumer, {
          children: function children(_ref2) {
            var handlePrint = _ref2.handlePrint;
            return /*#__PURE__*/_jsx(Button, {
              type: "primary",
              onClick: handlePrint,
              children: /*#__PURE__*/_jsx("b", {
                children: "IMPRIMER"
              })
            });
          }
        })
      })],
      children: /*#__PURE__*/_jsxs("div", {
        style: {
          textAlign: 'center'
        },
        ref: ref,
        children: [/*#__PURE__*/_jsx("div", {
          style: {
            width: '70px',
            textAlign: 'center !important'
          },
          children: /*#__PURE__*/_jsx("img", {
            src: "drawables/emgl.png",
            style: {
              width: '100%'
            }
          })
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("h2", {
          children: ["CODE PATIENT : ", customer.idnumber]
        }), /*#__PURE__*/_jsxs("h5", {
          children: ["Nom : ", customer.firstname + " " + customer.lastname]
        }), /*#__PURE__*/_jsx(List, {
          header: /*#__PURE__*/_jsx("div", {
            children: "Actes / Produit(s)"
          }),
          footer: /*#__PURE__*/_jsx("b", {
            children: "TOTAL (GNF) " + receipAmount.toLocaleString('fr')
          }),
          bordered: true,
          dataSource: rdata,
          renderItem: function renderItem(item) {
            return /*#__PURE__*/_jsx(List.Item, {
              children: /*#__PURE__*/_jsx(Typography.Text, {
                mark: true,
                children: item
              })
            });
          }
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("div", {
          children: ["REMISE ", discount, "% ", isPdaActive == 1 && /*#__PURE__*/_jsx("span", {
            style: {
              color: "#8F4F31"
            },
            children: "(*Paiement diff\xE9r\xE9 autoris\xE9)"
          })]
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("div", {
          style: {
            textAlign: "center"
          },
          children: createdBill && /*#__PURE__*/_jsx(QRCode, {
            type: "svg",
            value: "https://cik.cliniqueadmin.com/#/checkreceipt/" + createdBill.id.toString(),
            size: 65
          })
        }), /*#__PURE__*/_jsx("br", {}), userCompany != null && /*#__PURE__*/_jsx(Alert, {
          type: "warning",
          banner: true,
          message: "Prise en charge de " + userCompany.rate.toString() + "% par " + userCompany.label
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx("b", {
            children: "Adresse: Kissidougou, Korodou, Secteur II - Route Nationale N\xB01 - Tel: 622342787/621128638"
          })
        })]
      })
    })]
  });
};
export default PatientView;